// extracted by mini-css-extract-plugin
module.exports = {"btnGeneric":"FutureButton_btnGeneric_37YqN","activeFilter":"FutureButton_activeFilter_1c1_m"};